let a = 0;
function c(t = "ark") {
  return `${t}-${++a}`;
}
function d() {
  a = 0;
}
function o(t) {
  if (!(t instanceof HTMLElement) || t.disabled || t.hidden || t.getAttribute("aria-hidden") === "true") return !1;
  const r = t.getAttribute("tabindex");
  return r !== null && parseInt(r, 10) < 0 ? !1 : ["A", "BUTTON", "INPUT", "SELECT", "TEXTAREA", "DETAILS"].includes(t.tagName) ? !(t.tagName === "A" && !t.hasAttribute("href")) : r !== null && parseInt(r, 10) >= 0;
}
function u(t) {
  const r = t.querySelectorAll(
    'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"]), details'
  );
  return Array.from(r).filter(o);
}
function f(t) {
  const r = u(t), e = r[0], n = r[r.length - 1], i = (s) => {
    s.key === "Tab" && (s.shiftKey ? document.activeElement === e && (s.preventDefault(), n?.focus()) : document.activeElement === n && (s.preventDefault(), e?.focus()));
  };
  return t.addEventListener("keydown", i), () => {
    t.removeEventListener("keydown", i);
  };
}
function l(t, r = "polite") {
  const e = document.createElement("div");
  e.setAttribute("role", "status"), e.setAttribute("aria-live", r), e.setAttribute("aria-atomic", "true"), e.style.cssText = `
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  `, document.body.appendChild(e), requestAnimationFrame(() => {
    e.textContent = t;
  }), setTimeout(() => {
    document.body.removeChild(e);
  }, 1e3);
}
function b() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function p(t) {
  return t.getAttribute("role");
}
function m(t, r) {
  Object.entries(r).forEach(([e, n]) => {
    const i = e.startsWith("aria-") ? e : `aria-${e}`;
    n == null || n === !1 ? t.removeAttribute(i) : n === !0 ? t.setAttribute(i, "true") : t.setAttribute(i, n);
  });
}
export {
  u as a,
  l as b,
  p as c,
  c as g,
  o as i,
  b as p,
  d as r,
  m as s,
  f as t
};
//# sourceMappingURL=a11y-DxQW21Jt.js.map
